import { SVGProps } from 'react';

const Recycle = ({
  width = 21,
  height = 21,
  fill = '#2A2A2A',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    height={height + 'px'}
    width={width + 'px'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    {...otherProps}>
    <path
      d="M7.54141 4.98621C7.53018 4.46397 7.09831 4.04939 6.57605 4.05951L4.59467 4.09788C6.10038 2.70091 8.07038 1.91155 10.1242 1.8824C14.588 1.88892 17.7063 5.44096 18.176 9.06091C18.2431 9.57838 18.6605 10.0029 19.1824 10.0029C19.7042 10.0029 20.1318 9.57878 20.077 9.05986C19.5978 4.52321 15.7233 0 10.1242 0C7.67627 0.0144987 5.31764 0.92066 3.48965 2.54864L3.52182 1.0085C3.53272 0.486776 3.11872 0.0549462 2.597 0.0438468C2.07508 0.0327432 1.643 0.446884 1.63197 0.968806L1.52441 6.06109L6.6144 5.95358C7.13756 5.94253 7.55265 5.50937 7.54141 4.98621Z"
      fill={fill}
    />
    <path
      d="M10.0009 20.0071C12.4488 19.9926 14.8074 19.0864 16.6354 17.4585L16.6033 18.9986C16.5924 19.5203 17.0064 19.9522 17.5281 19.9633C18.05 19.9744 18.4821 19.5602 18.4931 19.0383L18.6007 13.946L13.5095 14.0536C12.987 14.0646 12.5723 14.4972 12.5835 15.0197C12.5945 15.5412 13.0255 15.9553 13.547 15.9457L15.53 15.9089C14.025 17.3056 12.0559 18.0949 10.003 18.1244C5.53683 18.1179 2.42049 14.5659 1.95115 10.9459C1.88406 10.4284 1.46662 10.0039 0.944823 10.0039C0.423017 10.0039 -0.00464295 10.4281 0.0502155 10.947C0.529823 15.4837 4.40604 20.0071 10.0009 20.0071Z"
      fill={fill}
    />
  </svg>
);

export default Recycle;
